import { render, staticRenderFns } from "./landmarkDetails.vue?vue&type=template&id=0a05ea8e"
import script from "./landmarkDetails.vue?vue&type=script&lang=js"
export * from "./landmarkDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports